// ==========================================
// PACK TYPES
//
// currency:   'stars' | 'ash' | 'ad'
// pool:       'standard' | 'ash' | 'ad'
// rarityRules: roll thresholds out of 1000
//   roll <= divine    → Divine
//   roll <= mythic    → Mythic
//   roll <= legendary → Legendary
//   roll <= epic      → Epic
//   roll <= rare      → Rare
//   else              → Common
//
// No Common drops in ash or ad packs.
// ==========================================

export const PACK_TYPES = {

  // ============================================================
  // STAR PACKS — purchased with Stars
  // ============================================================

  // ── Entry tier ──────────────────────────────────────────────
  BUDGET: {
    id: 'BUDGET',
    displayName: 'BUDGET PACK',
    cost: 50,
    currency: 'stars',
    cardCount: 1,
    art: '🧮',
    cssClass: 'budget',
    pool: 'standard',
    rarityRules: { divine: 0.05, mythic: 0.5, legendary: 10, epic: 50, rare: 200 },
  },
  NANO: {
    id: 'NANO',
    displayName: 'NANO PACK',
    cost: 75,
    currency: 'stars',
    cardCount: 1,
    art: '📏',
    cssClass: 'nano',
    pool: 'standard',
    rarityRules: { divine: 0.05, mythic: 0.6, legendary: 12, epic: 60, rare: 220 },
  },
  STANDARD: {
    id: 'STANDARD',
    displayName: 'STANDARD PACK',
    cost: 100,
    currency: 'stars',
    cardCount: 1,
    art: '📦',
    cssClass: 'standard',
    pool: 'standard',
    rarityRules: { divine: 0.1, mythic: 1.5, legendary: 25, epic: 120, rare: 350 },
  },

  // ── Mid tier ─────────────────────────────────────────────────
  PULSE: {
    id: 'PULSE',
    displayName: 'PULSE PACK',
    cost: 200,
    currency: 'stars',
    cardCount: 2,
    art: '⚡',
    cssClass: 'pulse',
    pool: 'standard',
    rarityRules: { divine: 0.15, mythic: 1.8, legendary: 30, epic: 130, rare: 360 },
  },
  GAMBLE: {
    id: 'GAMBLE',
    displayName: 'GAMBLE PACK',
    cost: 250,
    currency: 'stars',
    cardCount: 1,
    art: '🎲',
    cssClass: 'gamble',
    pool: 'standard',
    rarityRules: { divine: 3, mythic: 6, legendary: 10, epic: 14, rare: 18 },
  },
  PREMIUM: {
    id: 'PREMIUM',
    displayName: 'PREMIUM PACK',
    cost: 400,
    currency: 'stars',
    cardCount: 2,
    art: '💰',
    cssClass: 'premium',
    pool: 'standard',
    rarityRules: { divine: 0.5, mythic: 5, legendary: 60, epic: 250, rare: 500 },
  },
  LUCKY: {
    id: 'LUCKY',
    displayName: 'LUCKY PACK',
    cost: 500,
    currency: 'stars',
    cardCount: 1,
    art: '🍀',
    cssClass: 'lucky',
    pool: 'standard',
    rarityRules: { divine: 1, mythic: 10, legendary: 120, epic: 250, rare: 350 },
  },
  VOID_PACK: {
    id: 'VOID_PACK',
    displayName: 'VOID PACK',
    cost: 600,
    currency: 'stars',
    cardCount: 2,
    art: '🌑',
    cssClass: 'void',
    pool: 'standard',
    rarityRules: { divine: 0.1, mythic: 1, legendary: 20, epic: 100, rare: 500 },
  },
  PLASMA: {
    id: 'PLASMA',
    displayName: 'PLASMA PACK',
    cost: 800,
    currency: 'stars',
    cardCount: 3,
    art: '🔋',
    cssClass: 'plasma',
    pool: 'standard',
    rarityRules: { divine: 0.3, mythic: 3, legendary: 50, epic: 200, rare: 600 },
  },

  // ── High tier ─────────────────────────────────────────────────
  BIG: {
    id: 'BIG',
    displayName: 'BIG PACK',
    cost: 1000,
    currency: 'stars',
    cardCount: 5,
    art: '📚',
    cssClass: 'big',
    pool: 'standard',
    rarityRules: { divine: 0.2, mythic: 3, legendary: 50, epic: 150, rare: 300 },
  },
  STORM: {
    id: 'STORM',
    displayName: 'STORM PACK',
    cost: 1500,
    currency: 'stars',
    cardCount: 8,
    art: '⛈️',
    cssClass: 'storm',
    pool: 'standard',
    rarityRules: { divine: 0.2, mythic: 2, legendary: 30, epic: 130, rare: 370 },
  },
  TITAN: {
    id: 'TITAN',
    displayName: 'TITAN PACK',
    cost: 2000,
    currency: 'stars',
    cardCount: 4,
    art: '🐉',
    cssClass: 'titan',
    pool: 'standard',
    rarityRules: { divine: 0.5, mythic: 5, legendary: 200, epic: 450, rare: 700 },
  },
  GOLDEN: {
    id: 'GOLDEN',
    displayName: 'GOLDEN PACK',
    cost: 2000,
    currency: 'stars',
    cardCount: 10,
    art: '👑',
    cssClass: 'golden',
    pool: 'standard',
    rarityRules: { divine: 3, mythic: 15, legendary: 180, epic: 250, rare: 500 },
  },
  MEGA: {
    id: 'MEGA',
    displayName: 'MEGA PACK',
    cost: 2500,
    currency: 'stars',
    cardCount: 20,
    art: '💎',
    cssClass: 'mega',
    pool: 'standard',
    rarityRules: { divine: 0.1, mythic: 1.5, legendary: 25, epic: 120, rare: 350 },
  },
  QUANTUM: {
    id: 'QUANTUM',
    displayName: 'QUANTUM PACK',
    cost: 3000,
    currency: 'stars',
    cardCount: 5,
    art: '⚛️',
    cssClass: 'quantum',
    pool: 'standard',
    rarityRules: { divine: 1, mythic: 10, legendary: 120, epic: 300, rare: 600 },
  },
  SINGULARITY: {
    id: 'SINGULARITY',
    displayName: 'SINGULARITY PACK',
    cost: 4000,
    currency: 'stars',
    cardCount: 3,
    art: '🌀',
    cssClass: 'singularity',
    pool: 'standard',
    rarityRules: { divine: 2, mythic: 20, legendary: 200, epic: 400, rare: 700 },
  },

  // ── Endgame tier ──────────────────────────────────────────────
  HEAVYHITTER: {
    id: 'HEAVYHITTER',
    displayName: 'HEAVY HITTER',
    cost: 5000,
    currency: 'stars',
    cardCount: 5,
    art: '💥',
    cssClass: 'heavyhitter',
    pool: 'standard',
    rarityRules: { divine: 2, mythic: 20, legendary: 240, epic: 100, rare: 200 },
  },
  CELESTIAL: {
    id: 'CELESTIAL',
    displayName: 'CELESTIAL PACK',
    cost: 7500,
    currency: 'stars',
    cardCount: 3,
    art: '✨',
    cssClass: 'celestial',
    pool: 'standard',
    rarityRules: { divine: 5, mythic: 30, legendary: 200, epic: 400, rare: 700 },
  },
  ENDGAME: {
    id: 'ENDGAME',
    displayName: 'ENDGAME PACK',
    cost: 10000,
    currency: 'stars',
    cardCount: 5,
    art: '🏆',
    cssClass: 'endgame',
    pool: 'standard',
    rarityRules: { divine: 5, mythic: 50, legendary: 500, epic: 300, rare: 200 },
  },
  APEX: {
    id: 'APEX',
    displayName: 'APEX PACK',
    cost: 15000,
    currency: 'stars',
    cardCount: 10,
    art: '🚀',
    cssClass: 'apex',
    pool: 'standard',
    rarityRules: { divine: 8, mythic: 60, legendary: 400, epic: 300, rare: 232 },
  },
  OMEGA: {
    id: 'OMEGA',
    displayName: 'OMEGA PACK',
    cost: 25000,
    currency: 'stars',
    cardCount: 10,
    art: '🛸',
    cssClass: 'omega',
    pool: 'standard',
    rarityRules: { divine: 15, mythic: 100, legendary: 500, epic: 385, rare: 0 },
  },

  // ============================================================
  // ASH PACKS — purchased with Ash currency
  // No Commons — minimum Rare drop guaranteed.
  // ============================================================

  ASH_SPARK: {
    id: 'ASH_SPARK',
    displayName: 'ASH SPARK',
    cost: 50,
    currency: 'ash',
    cardCount: 1,
    art: '🔥',
    cssClass: 'ash-spark',
    pool: 'ash',
    rarityRules: { divine: 1, mythic: 8, legendary: 80, epic: 300, rare: 1000 },
  },
  ASH_BLAZE: {
    id: 'ASH_BLAZE',
    displayName: 'ASH BLAZE',
    cost: 150,
    currency: 'ash',
    cardCount: 3,
    art: '🔥🔥',
    cssClass: 'ash-blaze',
    pool: 'ash',
    rarityRules: { divine: 3, mythic: 20, legendary: 150, epic: 500, rare: 1000 },
  },
  ASH_PYRE: {
    id: 'ASH_PYRE',
    displayName: 'ASH PYRE',
    cost: 250,
    currency: 'ash',
    cardCount: 2,
    art: '🔥',
    cssClass: 'ash-pyre',
    pool: 'ash',
    rarityRules: { divine: 5, mythic: 30, legendary: 200, epic: 600, rare: 1000 },
  },
  ASH_INFERNO: {
    id: 'ASH_INFERNO',
    displayName: 'ASH INFERNO',
    cost: 400,
    currency: 'ash',
    cardCount: 5,
    art: '🔥🔥🔥',
    cssClass: 'ash-inferno',
    pool: 'ash',
    rarityRules: { divine: 8, mythic: 50, legendary: 300, epic: 700, rare: 1000 },
  },
  ASH_SUPERNOVA: {
    id: 'ASH_SUPERNOVA',
    displayName: 'ASH SUPERNOVA',
    cost: 750,
    currency: 'ash',
    cardCount: 5,
    art: '💥',
    cssClass: 'ash-supernova',
    pool: 'ash',
    rarityRules: { divine: 15, mythic: 80, legendary: 400, epic: 800, rare: 1000 },
  },
  ASH_SINGULARITY: {
    id: 'ASH_SINGULARITY',
    displayName: 'ASH SINGULARITY',
    cost: 1500,
    currency: 'ash',
    cardCount: 10,
    art: '☄️',
    cssClass: 'ash-singularity',
    pool: 'ash',
    rarityRules: { divine: 30, mythic: 150, legendary: 600, epic: 900, rare: 1000 },
  },

  // ============================================================
  // AD PACKS — watch an ad to open (free, exclusive cards)
  // ============================================================

  AD_SIGNAL: {
    id: 'AD_SIGNAL',
    displayName: 'SIGNAL PACK',
    cost: 0,
    currency: 'ad',
    cardCount: 1,
    art: '📡',
    cssClass: 'ad-pack',
    pool: 'ad',
    rarityRules: { divine: 2, mythic: 15, legendary: 150, epic: 450, rare: 1000 },
  },
  AD_PRISM: {
    id: 'AD_PRISM',
    displayName: 'PRISM PACK',
    cost: 0,
    currency: 'ad',
    cardCount: 2,
    art: '💠',
    cssClass: 'ad-pack-prism',
    pool: 'ad',
    rarityRules: { divine: 3, mythic: 20, legendary: 200, epic: 500, rare: 1000 },
  },
  AD_RADIANT: {
    id: 'AD_RADIANT',
    displayName: 'RADIANT PACK',
    cost: 0,
    currency: 'ad',
    cardCount: 1,
    art: '✨',
    cssClass: 'ad-pack-radiant',
    pool: 'ad',
    rarityRules: { divine: 5, mythic: 30, legendary: 250, epic: 600, rare: 1000 },
  },
};